const BlogCatalog = () => import('@/views/modules/beauty/BlogCatalog.vue');
const SingleBlog = () => import('@/views/modules/beauty/SingleBlog.vue');
const VideoCatalog = () => import('@/views/modules/beauty/VideoCatalog.vue');
const SingleVideo = () => import('@/views/modules/beauty/SingleVideo.vue');
const FavoritesVideo = () =>
    import('@/views/my-profile/FavoritesVideo.vue');
const BeautyPlanner = () => import('@/views/modules/beauty/BeautyPlanner.vue');

export default [
    {
        path: '/blog/catalog',
        name: 'blog-catalog',
        component: BlogCatalog,
        meta: { allowedSubdomains: ['portal'], hideForPortalTypeBooks: true },
    },
    {
        path: '/blog/:id',
        name: 'single-blog',
        component: SingleBlog,
        meta: { requiresAuth: true, allowedSubdomains: ['portal'], hideForPortalTypeBooks: true  },
    },
    {
        path: '/video/catalog',
        name: 'video-catalog',
        component: VideoCatalog,
        meta: { allowedSubdomains: ['portal'], hideForPortalTypeBooks: true },
    },
    {
        path: '/video/:id',
        name: 'single-video',
        component: SingleVideo,
        meta: { requiresAuth: true, allowedSubdomains: ['portal'], hideForPortalTypeBooks: true },
    },
    {
        path: '/my-profile/favorites',
        name: 'favorites-video',
        component: FavoritesVideo,
        meta: { requiresAuth: true, allowedSubdomains: ['portal'], hideForPortalTypeBooks: true },
    },
    {
        path: '/planner',
        name: 'beauty-planner',
        component: BeautyPlanner,
        meta: { allowedSubdomains: ['portal'], hideForPortalTypeBooks: true },
    },
];
